export default "#pageHeader {\n  display: none;\n}\n\n#pageBreadcrumb {\n  display: none;\n}\n\n#pageBottom {\n  display: none;\n}\n\n#pageContentScroll > :first-child {\n  display: none;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader/dist/cjs.js!./src/stores/catalog/flexLayout/flexComponents/content-panels/c8-component-wrappers/hideC8.css
// module id = 1132
// module chunks = 10